import React from 'react';
import { number, string } from 'prop-types';
import classnames from 'classnames';
import { Bubble } from './components';
import './Bubbles.scss';

export default function Bubbles({ className, activeIndex, length }) {
    const rootClassnames = classnames('bubbles', className);

    return (
        <div className={rootClassnames}>
            <div className="bubbles__container">
                {[...new Array(length).keys()].map(index => (
                    <Bubble
                        key={index}
                        className="bubbles__container__bubble"
                        active={index === activeIndex}
                    />
                ))}
            </div>
        </div>
    );
}

Bubbles.propTypes = {
    activeIndex: number.isRequired,
    length: number.isRequired,
    className: string,
};

Bubbles.defaultProps = {
    className: null,
};
